(function () {
  var CEP_KEY = 'hoad_shipping_cep';

  var MONEY_FORMATTER = (function () {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return null;
    }
  })();

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    if (MONEY_FORMATTER) return MONEY_FORMATTER.format(value);
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  function getStoredCep() {
    try {
      var raw = localStorage.getItem(CEP_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setStoredCep(data) {
    try {
      localStorage.setItem(CEP_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  }

  function clearStoredCep() {
    try {
      localStorage.removeItem(CEP_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function inRange(n, a, b) {
    return n >= a && n <= b;
  }

  // Faixas de CEP por estado (Correios/IBGE, dado público) -> só as 3
  // regiões que a HOAD usa pro frete grátis: Santa Catarina isolada,
  // Sul+Sudeste juntos, resto do Brasil. Mesma lógica do carrinho antigo
  // (removida de lá, movida pra cá — ver ATIVIDADES.md).
  function cepToRegion(cepDigits) {
    var prefix = parseInt(cepDigits.slice(0, 2), 10);
    if (inRange(prefix, 88, 89)) return 'sc';
    if (
      inRange(prefix, 1, 19) ||
      inRange(prefix, 20, 29) ||
      inRange(prefix, 30, 39) ||
      inRange(prefix, 80, 87) ||
      inRange(prefix, 90, 99)
    ) {
      return 'sul_sudeste';
    }
    return 'demais';
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function formatCepDisplay(cep) {
    if (!cep || cep.length !== 8) return cep || '';
    return cep.slice(0, 5) + '-' + cep.slice(5);
  }

  function renderCepForm(el, showError) {
    var form = el.querySelector('[data-hoad-cep-form]');
    var active = el.querySelector('[data-hoad-shipping-active]');
    var error = el.querySelector('[data-hoad-cep-error]');
    if (!form || !active) return;
    form.hidden = false;
    active.hidden = true;
    if (error) error.hidden = !showError;
  }

  // 23/09: o backend é outro domínio (ver hoad-reviews.js), então URL absoluta.
  var HOAD_API_BASE = 'https://app.hoad.com.br';
  var deliveryCache = {};
  var deliveryRequestId = 0;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderDelivery(el, opcoes) {
    var box = el.querySelector('[data-hoad-delivery]');
    var list = el.querySelector('[data-hoad-delivery-list]');
    if (!box || !list) return;
    if (!opcoes || !opcoes.length) {
      box.hidden = true;
      return;
    }
    list.innerHTML = opcoes.map(function (o) {
      return '<li><span>' + escapeHtml(o.label) + '</span><strong>até ' + escapeHtml(o.dataTexto) + '</strong></li>';
    }).join('');
    box.hidden = false;
  }

  function loadDelivery(el, cep) {
    var box = el.querySelector('[data-hoad-delivery]');
    if (!box) return;
    var requestId = ++deliveryRequestId;
    if (deliveryCache[cep]) {
      renderDelivery(el, deliveryCache[cep]);
      return;
    }
    box.hidden = true;
    var valor = ((parseInt(el.dataset.price, 10) || 0) / 100).toFixed(2);
    fetch(HOAD_API_BASE + '/api/geral/frenet-prazo?cep=' + encodeURIComponent(cep) + '&valor=' + valor)
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        deliveryCache[cep] = data.opcoes || [];
        if (requestId === deliveryRequestId) renderDelivery(el, deliveryCache[cep]);
      })
      .catch(function () { /* estimativa é complemento: falhou, some sem erro visível */ });
  }

  function renderActive(el, region, cep) {
    var form = el.querySelector('[data-hoad-cep-form]');
    var active = el.querySelector('[data-hoad-shipping-active]');
    if (!form || !active) return;

    var amount = parseInt(el.dataset['region' + capitalize(region) + 'Amount'], 10) || 0;
    var label = el.dataset['region' + capitalize(region) + 'Label'] || '';
    var price = parseInt(el.dataset.price, 10) || 0;

    if (!amount) {
      renderCepForm(el, false);
      return;
    }

    form.hidden = true;
    active.hidden = false;

    var message = active.querySelector('[data-hoad-shipping-message]');
    var fill = active.querySelector('[data-hoad-shipping-fill]');
    var cepDisplay = active.querySelector('[data-hoad-cep-display]');

    var reached = price >= amount;
    if (message) {
      message.innerHTML = reached
        ? '<strong>' + label + '</strong>'
        : 'Faltam <strong>' + formatMoney(amount - price) + '</strong> pra: ' + label;
    }
    if (fill) {
      var percent = amount > 0 ? Math.min((price / amount) * 100, 100) : 0;
      fill.style.width = percent + '%';
    }
    if (cepDisplay) {
      cepDisplay.textContent = formatCepDisplay(cep);
    }
    loadDelivery(el, cep);
  }

  function initCepForm(el) {
    var form = el.querySelector('[data-hoad-cep-submit]');
    var input = el.querySelector('[data-hoad-cep-input]');
    var changeBtn = el.querySelector('[data-hoad-cep-change]');

    if (form && !form.dataset.hoadBound) {
      form.dataset.hoadBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var digits = (input.value || '').replace(/\D/g, '');
        if (digits.length !== 8) {
          renderCepForm(el, true);
          return;
        }
        var region = cepToRegion(digits);
        setStoredCep({ cep: digits, region: region });
        renderActive(el, region, digits);
      });
    }

    if (changeBtn && !changeBtn.dataset.hoadBound) {
      changeBtn.dataset.hoadBound = 'true';
      changeBtn.addEventListener('click', function () {
        clearStoredCep();
        deliveryRequestId++;
        if (input) input.value = '';
        renderCepForm(el, false);
      });
    }
  }

  function processAll() {
    document.querySelectorAll('[data-hoad-shipping-estimator]').forEach(function (el) {
      initCepForm(el);

      var stored = getStoredCep();
      if (stored && stored.region) {
        renderActive(el, stored.region, stored.cep);
        return;
      }

      // Cliente logado com CEP cadastrado: usa direto, sem perguntar.
      var customerCep = (el.dataset.customerCep || '').replace(/\D/g, '');
      if (customerCep.length === 8) {
        var region = cepToRegion(customerCep);
        setStoredCep({ cep: customerCep, region: region });
        renderActive(el, region, customerCep);
        return;
      }

      renderCepForm(el, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }
})();
